import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Décors Multifestif - Décorations de Ballons à Montréal",
  description = "Spécialiste en décorations de ballons et événements spéciaux à Montréal. Location d'hélium, décors pour mariages, anniversaires et événements corporatifs.",
  keywords = "décoration ballons, ballons hélium Montréal, événements Montréal, mariage, anniversaire, corporatif, location hélium",
  canonical = "https://decorsmultifestif.com",
  image = "https://decorsmultifestif.com/logo-dm.png",
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_CA" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="author" content="Décors Multifestif" />
      <meta name="geo.region" content="CA-QC" />
      <meta name="geo.placename" content="Montreal" />
    </Helmet>
  );
};

export default SEO;
